import React from 'react';
import { keyframes } from '@emotion/react';
import { Box, makeStyles } from '@material-ui/core';


// Define styles using makeStyles
const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    //   height: '100vh',
    //   position: 'relative',
    },
    expandingCircle: {
      position: 'absolute',
      width: '40px', // Initial size of the circle
      height: '40px',
      borderRadius: '50%',
      border: `3px solid ${theme.palette.primary.main}`, // Circle border color
      animation: '$expand 1.5s infinite ease-out',
    },
    '@keyframes expand': {
      '0%': {
        transform: 'scale(1)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(3)', // Adjust scale for desired expansion size
        opacity: 0,
      },
    },
  }));

const ExpandCircleLoading = () => {
    const classes = useStyles();
    return (
        <Box className={classes.root}>
          <div className={classes.expandingCircle}></div>
          {/* <CircularProgress color="primary" /> */}
        </Box>
      );
};

export default ExpandCircleLoading;
